import React, { useCallback } from "react"
import styled from "styled-components"
import Color from "../../../../style/enum/color"
import { ChangeEvent } from "react"
import { Container, IContainerProps } from "./container"

const Component = (props: IContainerProps) => {
  const onChange = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      props.actions.updateTitle(target.value)
      // eslint-disable-next-line
    }, [])

  return (
    <StyledInput
      type="text"
      placeholder="タイトルを入力"
      autoFocus={true}
      value={props.title || ""}
      onChange={onChange}
    />
  )
}

export const Title = Container(Component)

const StyledInput = styled.input`
  color: ${Color.DIMGRAY};
  font-size: 1.5rem;
  line-height: 1.3;
  margin: 20px 0;
  padding: 15px 0;
  width: 100%;
  border-bottom: 1px solid ${Color.LIGHT_GRAY};
`
